import { GeneralService } from './general.service';
import { Injectable, ViewChild } from '@angular/core';
import { EnumSiaqs } from '../entity/enum/enum-siaqs';
import { Cd001CardClassificacaoIComponent } from '../views/form-cd001/form-cd001-classificacao/partialViews/cd001-card-classificacao-I.component';

@Injectable({
    providedIn: 'root'
})

export class SiaqsService {

    private hibridoRange?: boolean;
    private hibridoDesvioPadrao?: boolean;
    private peneiraG1?: boolean;
    private peneiraG2?: boolean;
    private peneiraG3?: boolean;
    private peneiraG4?: boolean;
    private peneiraG5?: boolean;
    private peneiraG6?: boolean;
    private peneiraG7?: boolean;
    private peneiraG8?: boolean;
    private statusRange?: boolean;
    private statusDesvioPadrao?: boolean;

    @ViewChild(Cd001CardClassificacaoIComponent, { static: false })
    cd001CardClassificacaoIComponent: Cd001CardClassificacaoIComponent;

    constructor(protected generalService: GeneralService) {

    }

    // tslint:disable-next-line: max-line-length
    public async getSiaqs(pHibrido: string, pPeneira: string, pRange: number, pStdv: number, pStatus: EnumSiaqs): Promise<string> {
        this.setProperties(pHibrido, pPeneira);
        await this.setStatus(pRange, pStdv);
        const resultado = await this.getSiaqsResult(pStatus);
        return resultado;
    }

    private async getSiaqsResult(pStatus: EnumSiaqs): Promise<string> {
        let result = '-';
        switch (pStatus) {
            case EnumSiaqs.Resultado_Siaqs:
                result = await this.getResultadoSiaqs();
                break;
            case EnumSiaqs.Motivo_Reprovacao_Siaqs:
                result = await this.getMotivoReprovacao();
                break;
        }
        return result;
    }

    private async getResultadoSiaqs(): Promise<string> {
        if (this.statusRange && this.statusDesvioPadrao) {
            return 'APROVADO';
        }
        return 'REPROVADO';
    }

    private async getMotivoReprovacao(): Promise<string> {
        if (!this.statusRange && this.statusDesvioPadrao) {
            return 'RANGE';
        } else if (this.statusRange && !this.statusDesvioPadrao) {
            return 'DESVIO PADRÃO';
        } else if (!this.statusRange && !this.statusDesvioPadrao) {
            return 'RANGE E DESVIO PADRÃO';
        } else if (!this.statusRange && this.statusDesvioPadrao) {
            return 'RANGE';
        } else if (this.statusRange && !this.statusDesvioPadrao) {
            return 'DESVIO PADRÃO';
        } else if (!this.statusRange && !this.statusDesvioPadrao) {
            return 'RANGE, DESVIO PADRÃO';
        }

        return '-';
    }

    private setProperties(pHibrido: string, pPeneira: string): void {
        this.setHibridoRange(pHibrido);
        this.setHibridoDesvioPadrao(pHibrido);
        this.setPeneiraG1(pPeneira);
        this.setPeneiraG2(pPeneira);
        this.setPeneiraG3(pPeneira);
        this.setPeneiraG4(pPeneira);
        this.setPeneiraG5(pPeneira);
        this.setPeneiraG6(pPeneira);
        this.setPeneiraG7(pPeneira);
        this.setPeneiraG8(pPeneira);
    }

    private async setStatus(pRange: number, pStdv: number): Promise<void> {
        // Efetuar a divisao do valor em porcentagem
        await this.setStatusRange(pRange);
        await this.setStatusDesvioPadrao(pStdv);
    }

    private async setStatusRange(pRange: number): Promise<void> {
        if ((this.peneiraG1 || this.peneiraG2) && this.hibridoRange && pRange <= 5) {
            this.statusRange = true;
        } else if (this.peneiraG3 && this.hibridoRange && pRange <= 4.9) {
            this.statusRange = true;
        } else if (this.peneiraG4 && this.hibridoRange && pRange <= 5.5) {
            this.statusRange = true;
        } else if (this.peneiraG5 && this.hibridoRange && pRange <= 4.5) {
            this.statusRange = true;
        } else if (this.peneiraG6 && this.hibridoRange && pRange <= 4) {
            this.statusRange = true;
        } else if (this.peneiraG7 && this.hibridoRange && pRange <= 4.05) {
            this.statusRange = true;
        } else if (this.peneiraG8 && this.hibridoRange && pRange <= 3.90) {
            this.statusRange = true;
        } else {
            this.statusRange = false;
        }
    }

    private async setStatusDesvioPadrao(pStdv: number): Promise<void> {
        if ((this.peneiraG1) && this.hibridoDesvioPadrao && pStdv <= 1) {
            this.statusDesvioPadrao = true;
        } else if (this.peneiraG5 && this.hibridoDesvioPadrao && pStdv <= 0.84) {
            this.statusDesvioPadrao = true;
        } else if (this.peneiraG6 && this.hibridoDesvioPadrao && pStdv <= 0.84) {
            this.statusDesvioPadrao = true;
        } else if (this.peneiraG1 && this.hibridoDesvioPadrao && pStdv <= 1.0) {
            this.statusDesvioPadrao = true;
        } else if ((this.peneiraG2 || this.peneiraG4) && this.hibridoDesvioPadrao && pStdv <= 0.94) {
            this.statusDesvioPadrao = true;
        } else if (this.peneiraG3 && this.hibridoDesvioPadrao && pStdv <= 0.92) {
            this.statusDesvioPadrao = true;
        } else if (this.peneiraG7 && this.hibridoDesvioPadrao && pStdv <= 0.80) {
            this.statusDesvioPadrao = true;
        } else if (this.peneiraG8 && this.hibridoDesvioPadrao && pStdv <= 0.74) {
            this.statusDesvioPadrao = true;
        } else {
            this.statusDesvioPadrao = false;
        }
    }

    public setHibridoRange(pHibrido: string): void {
        const hibrido = pHibrido || this.cd001CardClassificacaoIComponent.formulario.get('hibrido')?.value;
        if (!hibrido) {
            this.hibridoRange = false;
            return;
        }

        this.hibridoRange = this.checkHibridoRange(hibrido);
    }

    public setHibridoDesvioPadrao(pHibrido: string): void {
        const hibrido = pHibrido || this.cd001CardClassificacaoIComponent.formulario.get('hibrido')?.value;

        if (!hibrido) {
            this.hibridoDesvioPadrao = false;
            return;
        }

        this.hibridoDesvioPadrao = this.checkHibridoDesvioPadrao(hibrido);
    }

    private checkHibridoRange(hibrido: string): boolean {
        return !!hibrido?.trim();
    }

    private checkHibridoDesvioPadrao(hibrido: string): boolean {
        return !!hibrido?.trim();
    }

    private setPeneiraG1(Peneira: string): void {
        const arrPeneira: string[] = ['C1L', 'R1L'];
        this.peneiraG1 = arrPeneira.includes(Peneira?.trim()?.toUpperCase());
    }

    private setPeneiraG2(Peneira: string): void {
        const arrPeneira: string[] = ['C2L', 'R2L'];
        this.peneiraG2 = arrPeneira.includes(Peneira?.trim()?.toUpperCase());
    }

    private setPeneiraG3(Peneira: string): void {
        const arrPeneira: string[] = ['C3L', 'R3L'];
        this.peneiraG3 = arrPeneira.includes(Peneira?.trim()?.toUpperCase());
    }

    private setPeneiraG4(Peneira: string): void {
        const arrPeneira: string[] = ['C1M', 'R1M'];
        this.peneiraG4 = arrPeneira.includes(Peneira?.trim()?.toUpperCase());
    }

    private setPeneiraG5(Peneira: string): void {
        const arrPeneira: string[] = ['R2M', 'C2M'];
        this.peneiraG5 = arrPeneira.includes(Peneira?.trim()?.toUpperCase());
    }

    private setPeneiraG6(Peneira: string): void {
        const arrPeneira: string[] = ['R2', 'C2'];
        this.peneiraG6 = arrPeneira.includes(Peneira?.trim()?.toUpperCase());
    }

    private setPeneiraG7(Peneira: string): void {
        const arrPeneira: string[] = ['C3M', 'R3M'];
        this.peneiraG7 = arrPeneira.includes(Peneira?.trim()?.toUpperCase());
    }
    private setPeneiraG8(Peneira: string): void {
        const arrPeneira: string[] = ['C3', 'R3'];
        this.peneiraG8 = arrPeneira.includes(Peneira?.trim()?.toUpperCase());
    }
}
